<agr-table-v2 [dataSource]="dataSource" class="cow-overview__table-spaced-cols">
  <ng-container *agrTableTopBar [formGroup]="searchAndFilters">
    <div class="flex flex--row flex--justify-space-between flex--align-center">
      <div class="spacing--margin-top flex">
        @if (ReadOnlyMode === false) {
          <mat-form-field appearance="outline">
            <mat-label>{{ 'height-measurement.date' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [max]="maxDate"
              formControlName="measurementDate"
              placeholder="{{ 'height-measurement.select-date' | translate }}"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="datepickerDateClass" #picker></mat-datepicker>
          </mat-form-field>
        } @else {
          <mat-form-field appearance="outline">
            <mat-label>{{ 'height-measurement.date' | translate }}</mat-label>
            <mat-select
              formControlName="measurementDate"
              [value]="availableDates()[0]"
              [disabled]="availableDates().length === 0"
            >
              @for (date of availableDates(); track date) {
                <mat-option [value]="date">{{ date | agrDate: 'dd-MM-yyyy' }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <div class="padding-left">
          <p class="text--normal">
            {{ 'height-measurement.animalCount' | translate }} {{ dataSource.totalCount$ | async }}
          </p>
        </div>
        <div class="padding-left">
          <button mat-icon-button (click)="printTable()" title="Print table">
            <mat-icon>print</mat-icon>
          </button>
        </div>
      </div>
      @if (ReadOnlyMode === false) {
        <div>
          <button
            mat-flat-button
            (click)="cancelMeasurements()"
            [disabled]="!hasChanges() || isSaving()"
          >
            {{ 'height-measurement.buttons.cancel' | translate }}
          </button>
          <button
            mat-raised-button
            color="primary"
            class="spacing--margin-left"
            (click)="saveAllMeasurements()"
            [disabled]="!hasChanges() || isSaving() || hasInvalidForms()"
          >
            <div class="flex flex--align-center flex--row">
              <span> {{ 'height-measurement.buttons.save' | translate }} </span>
              @if (isSaving()) {
                <mat-spinner class="padding-left-small" diameter="20"></mat-spinner>
              }
            </div>
          </button>
        </div>
      } @else {
        <div>
          <button
            mat-raised-button
            color="secondary"
            [routerLink]="['/measurements']"
            [queryParams]="{ date: searchAndFilters.get('measurementDate').value }"
          >
            {{ 'height-measurement.buttons.edit-measurements' | translate }}
          </button>
        </div>
      }
    </div>
  </ng-container>

  <ng-container matColumnDef="registrationNumber">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'height-measurement.table.registrationNumber' | translate }}
    </th>
    <td
      mat-cell
      [attr.aria-label]="'height-measurement.table.registrationNumber' | translate"
      *matCellDef="let row"
    >
      {{ row.registrationNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="earNumber">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="sortable-header"
      (click)="sortData('earNumber')"
      (keydown.enter)="sortData('earNumber')"
      (keydown.space)="sortData('earNumber'); $event.preventDefault()"
      tabindex="0"
    >
      <span class="header-content">
        {{ 'height-measurement.table.earNumber' | translate }}
        @if (sortColumn() === 'earNumber') {
          <mat-icon class="sort-icon">{{
            sortDirection() === 'asc' ? 'arrow_upward' : 'arrow_downward'
          }}</mat-icon>
        } @else {
          <mat-icon class="sort-icon unfold-icon">unfold_more</mat-icon>
        }
      </span>
    </th>
    <td
      mat-cell
      [attr.aria-label]="'height-measurement.table.earNumber' | translate"
      *matCellDef="let row"
    >
      {{ row.earNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'height-measurement.table.name' | translate }}
    </th>
    <td
      mat-cell
      [attr.aria-label]="'height-measurement.table.name' | translate"
      *matCellDef="let row"
    >
      {{ row.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="ageInMonths">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="sortable-header"
      (click)="sortData('ageInMonths')"
      (keydown.enter)="sortData('ageInMonths')"
      (keydown.space)="sortData('ageInMonths'); $event.preventDefault()"
      tabindex="0"
    >
      <span class="header-content">
        {{ 'height-measurement.table.ageInMonths' | translate }}
        @if (sortColumn() === 'ageInMonths') {
          <mat-icon class="sort-icon">{{
            sortDirection() === 'asc' ? 'arrow_upward' : 'arrow_downward'
          }}</mat-icon>
        } @else {
          <mat-icon class="sort-icon unfold-icon">unfold_more</mat-icon>
        }
      </span>
    </th>
    <td
      mat-cell
      [attr.aria-label]="'height-measurement.table.ageInMonths' | translate"
      *matCellDef="let row"
    >
      {{ row.ageInMonths }}
    </td>
  </ng-container>

  <ng-container matColumnDef="dateOfBirth">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'height-measurement.table.dateOfBirth' | translate }}
    </th>
    <td
      mat-cell
      [attr.aria-label]="'height-measurement.table.dateOfBirth' | translate"
      *matCellDef="let row"
    >
      {{ row.dateOfBirth | agrDate: 'shortDate' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="hipHeight">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'height-measurement.table.hipHeight' | translate }}
    </th>
    <td
      mat-cell
      [attr.aria-label]="'height-measurement.table.hipHeight' | translate"
      *matCellDef="let row"
    >
      @if (!ReadOnlyMode) {
        @if (getMeasurementForm(row); as form) {
          <div class="error-tooltip-container">
            <mat-form-field appearance="outline" [formGroup]="form" class="measurement-field">
              <input
                matInput
                type="number"
                formControlName="hipHeight"
                (blur)="onHipHeightChange(row, form.get('hipHeight')?.value)"
                min="75"
                max="175"
              />
            </mat-form-field>
            @if (form.get('hipHeight')?.invalid && form.get('hipHeight')?.touched) {
              <mat-error class="word-break">
                {{ 'height-measurement.validation.hipHeightError' | translate }}
              </mat-error>
            }
          </div>
        }
      } @else {
        {{ row.heightCm }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="bcs">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'height-measurement.table.bcs' | translate }}
    </th>
    <td
      mat-cell
      [attr.aria-label]="'height-measurement.table.bcs' | translate"
      *matCellDef="let row"
    >
      @if (!ReadOnlyMode) {
        @if (getMeasurementForm(row); as form) {
          <div class="error-tooltip-container">
            <mat-form-field appearance="outline" [formGroup]="form" class="measurement-field">
              <input
                matInput
                type="number"
                formControlName="bodyConditionScore"
                (blur)="onBcsChange(row)"
                [ngClass]="{ 'bcs-default': !isBcsManuallyChanged(row) }"
                min="1"
                max="5"
                step="0.5"
              />
            </mat-form-field>
            @if (
              form.get('bodyConditionScore')?.invalid && form.get('bodyConditionScore')?.touched
            ) {
              <mat-error class="word-break">
                {{ 'height-measurement.validation.bcsError' | translate }}
              </mat-error>
            }
          </div>
        }
      } @else {
        {{ row.bodyConditionScore }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'height-measurement.table.actions' | translate }}
    </th>
    <td
      mat-cell
      [attr.aria-label]="'height-measurement.table.actions' | translate"
      *matCellDef="let row"
    >
      <button
        mat-icon-button
        [disabled]="!getMeasurementForm(row)?.get('hipHeight')?.value"
        (click)="deleteMeasurement(row)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
  <tr mat-row *matRowDef="let _; columns: displayColumns"></tr>
  <tr *matNoDataRow>
    <td class="text--center" [attr.colspan]="displayColumns.length">
      <agr-notification-empty
        data-test="hierarchical-data__empty"
        [isEmpty]="true"
        [emptyTitle]="'height-measurement.empty-title' | translate"
        [emptyDescription]="'height-measurement.empty-description' | translate"
        [emptyImage]="'/assets/images/no-items-3.png'"
        [emptyActionIcon]="'history'"
        [emptyActionText]="'height-measurement.reset-filters' | translate"
        [showEmptyAction]="!ReadOnlyMode"
        (emptyAction)="resetFilters()"
        class="spacing--margin-top"
      ></agr-notification-empty>
    </td>
  </tr>
</agr-table-v2>

<cow-table-print
  [printTableData]="printTableData"
  [measurementDate]="measurementDateForPrint"
  [location]="location"
/>
